import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendImageStyle, BackendMutationCreateImageStyleArgs } from 'src/types/backend';

import { FRAGMENT_IMAGE_STYLE } from './schema';

const MUTATION = gql`
  mutation CreateImageStyle($visualLanguageId: ID!, $name: String!, $customerResourceIds: [ID!]!) {
    createImageStyle(
      visualLanguageId: $visualLanguageId
      name: $name
      customerResourceIds: $customerResourceIds
    ) {
      ...ImageStyle
    }
  }
  ${FRAGMENT_IMAGE_STYLE}
`;

type Variables = BackendMutationCreateImageStyleArgs;
type Result = BackendImageStyle;

export const createImageStyle = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
